import Sortable from 'sortablejs'

const tableMixin = {
  methods: {
    /**
     * 显示表格编辑器
     */
    onShowTableEditor() {
      this.tableMode = 'ADD'
      this.tableHeader = ''
      this.tableData = []
      this.onAddTableRow()
      this.dialogTableVisible = !0
      const _this = this
      this.$nextTick(() => {
        const table = document.querySelector('.el-table__body-wrapper tbody')
        Sortable.create(table, {
          onEnd({ newIndex, oldIndex }) {
            const targetRow = _this.tableData.splice(oldIndex, 1)[0]
            _this.tableData.splice(newIndex, 0, targetRow)
            // 清空表头的值
            document.querySelector('.table_header__input').value = ''
          },
        })
      })
    },
    /**
     * 新增表格行
     */
    onAddTableRow() {
      this.tableData.push({
        key: '',
        value: '',
        show: false,
        rowKey: new Date().getTime().toString(),
      })
    },
    /**
     * 删除表格行
     * @param index {number} 表格行索引
     */
    onRemoveTableRow(index) {
      this.tableData.splice(index, 1)
    },
    /**
     * 保存表格
     */
    onSaveTable() {
      const table = document.createElement('table')
      const tbody = document.createElement('tbody')
      const thead = document.createElement('thead')

      const theadTh = document.createElement('th')
      theadTh.colSpan = 2
      theadTh.innerHTML = this.tableHeader

      const theadTr = document.createElement('tr')
      theadTr.appendChild(theadTh)

      thead.appendChild(theadTr)

      for (const row of this.tableData.values()) {
        const tr = document.createElement('tr')
        const keyTd = document.createElement('td')
        const valueTd = document.createElement('td')

        keyTd.innerHTML = row.key
        valueTd.innerHTML = row.value

        tr.appendChild(keyTd)
        tr.appendChild(valueTd)
        tbody.appendChild(tr)
      }

      table.appendChild(thead)
      table.appendChild(tbody)

      if (this.tableMode === 'ADD') {
        this.packageDOMElement(table, 'TABLE')
      } else {
        const tbodyData = [...this.tableData]
        const selectedArea = document.getElementById(this.selectedAreaId)
        selectedArea.dataset.data = JSON.stringify({
          type: 'TABLE',
          data: {
            tbody: tbodyData,
            thead: this.tableHeader,
          },
        })
        selectedArea.innerHTML = ''
        selectedArea.appendChild(table)
      }
      this.getAllTableData()
      this.dialogTableVisible = !1
    },
    /*
     * 获取编辑器里面所有表格的数据
     * */
    getAllTableData() {
      const els = document.getElementsByTagName('table')
      const dataList = []
      for (let i = 0; i < els.length; i++) {
        if (els[i].parentElement.className.includes('area__container')) {
          const { data } = JSON.parse(els[i].parentElement.dataset.data)
          for (const item of data.tbody) {
            dataList.push(item)
          }
        }
      }
      const list = dataList.filter(item => item.show === true)
      this.setPosterData(list)
    },
  },
}
export default tableMixin
